/**
 * StatusChip - Compact status indicator with industrial styling
 * Uses rounded-sm instead of rounded-full for a more professional look
 */

const STATUS_STYLES = {
  // Job/Work Order statuses
  not_started: 'bg-slate-100 text-slate-700 border-slate-200',
  in_production: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  partially_shipped: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  ready_for_shipment: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  closed: 'bg-slate-50 text-slate-500 border-slate-200',

  // Kanban-specific statuses
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  on_hold: 'bg-amber-50 text-amber-700 border-amber-200',
  cancelled: 'bg-red-50 text-red-700 border-red-200',
  archived: 'bg-slate-100 text-slate-400 border-slate-200',

  // Default
  default: 'bg-slate-100 text-slate-600 border-slate-200',
};

const STATUS_LABELS = {
  not_started: 'Not Started',
  in_production: 'In Production',
  partially_shipped: 'Partially Shipped',
  ready_for_shipment: 'Ready to Ship',
  closed: 'Closed',
  active: 'Active',
  on_hold: 'On Hold',
  cancelled: 'Cancelled',
  archived: 'Archived',
};

export default function StatusChip({ status, size = 'sm', className = '' }) {
  const styleClass = STATUS_STYLES[status] || STATUS_STYLES.default;
  const label = STATUS_LABELS[status] || status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Unknown';

  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-sm border
        ${styleClass}
        ${sizeClasses[size] || sizeClasses.sm}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {label}
    </span>
  );
}

// Export utilities for custom usage
export { STATUS_STYLES, STATUS_LABELS };
